import React from 'react';

import {fetchEventLocations} from '../../data/fetch';
import {useStoredDataChanged} from './useStoredDataChanged';
import Loader from './Loader';

const LoadLocations = ({eventId, children}) => {
    useStoredDataChanged();
    return (
        <Loader skipSpinner={state => state.events[eventId]?.locations.loaded} promises={[fetchEventLocations(eventId)]}>
            {children}
        </Loader>
    );
};

export default LoadLocations;
